// Session-based URL utilities for search conversations

export interface SessionParams {
    sessionId: string;
}

/**
 * Generate a UUID v4
 */
const generateUUID = (): string => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

/**
 * Get session ID from URL path
 */
export const getSessionIdFromUrl = (): string | null => {
    const pathParts = window.location.pathname.split('/');
    const searchIndex = pathParts.indexOf('search');
    
    if (searchIndex !== -1 && pathParts[searchIndex + 1]) {
        return pathParts[searchIndex + 1];
    }
    
    return null;
};

/**
 * Generate a new session ID using UUID format
 */
export const generateSessionId = (): string => {
    return generateUUID();
};

/**
 * Build session-based search URL
 */
export const buildSessionUrl = (sessionId: string): string => {
    return `/search/${sessionId}`;
};

/**
 * Navigate to a session-based search URL
 */
export const navigateToSession = (navigate: (path: string) => void, sessionId?: string): string => {
    const id = sessionId || generateSessionId();
    const url = buildSessionUrl(id);
    navigate(url);
    return id;
};

/**
 * Update current URL with session ID
 */
export const updateUrlWithSession = (sessionId: string): void => {
    const url = buildSessionUrl(sessionId);
    window.history.replaceState({}, '', url);
};
